// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { scaleToGrid } from '../../../../../utils/grid/gridUtils';
import { getThemeIsDarkMode } from '../../../../../user/account/accountModal/interface/themeSettings/themeSelector';

// Components
import ElectronLink from '../../../../../components/electron/ElectronLink';
import PopupEmptyElementListPlaceholder from '../../../../../components/popupPanel/types/empty/PopupEmptyElementListPlaceholder';

// Styles
import './TrashPopupEmptyPlaceholder.scss';

const mapStateToProps = createStructuredSelector({
    isDarkMode: getThemeIsDarkMode,
});

const TrashPopupOthersEmptyPlaceholder = ({ hasOlder, gridSize, isDarkMode }) => (
    <PopupEmptyElementListPlaceholder
        className="TrashPopupEmptyPlaceholder"
        img={
            <img
                src={isDarkMode ? require('./empty-trash-dark.png') : require('./empty-trash.png')}
                alt="Empty inbox"
                width={scaleToGrid(220, gridSize)}
                height={scaleToGrid(161, gridSize)}
                draggable={false}
            />
        }
        tip="Anything deleted by other users within your shared boards will be moved here"
    >
        {hasOlder && (
            <div className="trash-end-of-results">
                <p className="question">Want to recover something that was deleted more than a week ago?</p>
                <p className="cta">
                    Upgrade for three months history&nbsp;&nbsp;
                    <ElectronLink to="/free-plan/upgrade">Find out more</ElectronLink>
                </p>
            </div>
        )}
    </PopupEmptyElementListPlaceholder>
);

TrashPopupOthersEmptyPlaceholder.propTypes = {
    hasOlder: PropTypes.bool,
    gridSize: PropTypes.number,
    isDarkMode: PropTypes.bool,
};

export default connect(mapStateToProps)(TrashPopupOthersEmptyPlaceholder);
